module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DataTablePageNew', {
    ref: "dataQuery",
    attrs: {
      "mainColumn": "",
      "longColumn": "",
      "title": "月用水波动分析",
      "resource": _vm.resource,
      "operation": _vm.operation,
      "operationWidth": 80,
      "tableFullList": _vm.tableFullList,
      "tableInitList": _vm.tableInitList,
      "filterFullList": _vm.filterFullList,
      "filterInitList": _vm.filterInitList,
      "columns": _vm.columns
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-686f0cfa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/TelnetReading/MonthAnalysis.vue
// module id = 1767
// module chunks = 1